import { trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import openDepositProtectionModal from '../DepositProtectionModal';

import Button from '../Button';

import styles from './DepositProtectionLabelDescription.module.scss';

const DepositProtectionLabelDescription = () => {
  const handleOnClick = () => {
    SoyuzAnalytics.sendGA4Event('deposit-protection-more', {});
    openDepositProtectionModal();
  };

  return (
    <span className={styles['deposit-protection-label-description']}>
      {trans('listing.labels.deposit-protected.description')}{' '}
      <Button color="link" onClick={handleOnClick}>
        {trans('home-ll.cta')}
      </Button>
    </span>
  );
};

export default DepositProtectionLabelDescription;
